import { render } from "./FpLoading.vue?vue&type=template&id=78cd96d8&lang=pug"
import script from "./FpLoading.vue?vue&type=script&lang=js"
export * from "./FpLoading.vue?vue&type=script&lang=js"

import "./FpLoading.vue?vue&type=style&index=0&id=78cd96d8&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__